import React from "react";

const Heading = ({ text }) => {
  return (
    <div className="col-sm-12">
      <h1 className="text-medium">{text}</h1>
    </div>
  );
};

export default Heading;
